/**
 * Created by Julio Perez on 3/11/2016.
 */

// import './bar-chart.css'

import routing from './scatterplot.route.js';

import scatterplot from './scatterplot.directive';

////SERVICES
import scatterplotService from '../../services/scatterplot.service';

export default angular
    .module('scatterplot', [
        scatterplot,
        scatterplotService
    ])
    .config(routing)
    .name;



// WEBPACK FOOTER //
// ./src/app/emxd-charts/scatterplot/index.js